import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderSharingNewUnMount = (data) => openPopupHelper({ popupName: popupNames.UNMOUNT_DIALOG, data });
